<template>
  <div class="flex-between divider-bar">
    <div>
      <span class="divider"></span>
      <span class="text">{{ text }}</span>
    </div>
    <slot name="action" class="action"></slot>
  </div>
</template>

<script>
export default {
  name: 'DividerBar',
  props: {
    text: {
      type: String
    },
    icon: {
      type: String
    },
    iconCall: {
      type: Function,
      default: null
    }
  },
  methods: {
    handleClick() {
      this.iconCall && this.iconCall();
    }
  },
}
</script>

<style lang="scss" scoped>
.divider-bar {
  box-sizing: border-box;
  padding: 16px;
  background-color: #F5F7FA;
  margin: 20px 0;
  .divider {
    width: 4px;
    background-color: #1989FF;
    display: inline-block;
    height: 1em;
    margin: 0 10px;
    vertical-align: middle;
    position: relative;
  }
  .text {
    color: #333;
    font-weight: 600;
    font-size: 16px;
    vertical-align: middle;
  }
  .icon {
    cursor: pointer;
    margin-left: 10px;
    color: #1989FF;
    font-size: 20px;
  }

}
</style>